import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import Layout from '../shared/Layout';
import Icon from '../../components/tables/Icon';
import IconGoBack from '../../components/icons/IconGoBack';
import GameModal from './GameModal';
import GameCardsEditor from './GameCardsEditor';
import { getGameType, gamePlayUrlPrefix } from '../../variables/gameTypes';
import '../../css/groups.css';
import '../../css/games.css';

// Detail page for a single game instance (route /games/:id) - replaces the
// old per-type gridcards/quizcards/letters/matchexamples pages.
export default function GameCard() {
   const { id } = useParams();
   const navigate = useNavigate();
   const [game, setGame] = useState(null);
   const [modalState, setModalState] = useState('none');
   const [refreshKey, setRefreshKey] = useState(0);

   useEffect(() => {
      axios.get('/api/grid/' + id, { withCredentials: true })
         .then(response => setGame(response.data))
         .catch(err => { if(err.response && err.response.status === 401) navigate('/login'); });
   }, [id, navigate, refreshKey]);

   const bumpRefresh = () => setRefreshKey(prev => prev + 1);
   const stateHundler = (state) => { if(state === 'edit') setModalState('edit'); };
   const closeModal = () => setModalState('none');
   const onSaved = () => { closeModal(); bumpRefresh(); };
   const onDeleted = () => navigate('/games');

   if(!game) {
      return (
         <Layout>
            <main className="main-block">
               <div className="main-content txt-c games-page">Завантаження...</div>
            </main>
         </Layout>
      );
   }

   const gameType = getGameType(game.type);
   const clearurl = gamePlayUrlPrefix(game.type);

   return (
      <Layout>
         <main className="main-block">
            <div className="main-content txt-c games-page">
               <div className="game-detail-header" style={{ '--accent': gameType.accent }}>
                  <div className="group-card-back" onClick={() => navigate('/games')} title="До ігор">
                     <IconGoBack />
                  </div>
                  <span className="game-card-type-badge">{gameType.label}</span>
                  <div className="group-card-title">{game.name}</div>
                  <div className="group-card-header-actions">
                     <Icon mode="edit" id={id} stateHundler={stateHundler} className="icon-edit" classes="icon-dimensions-big" />
                     <Icon mode="copy-url" clearurl={clearurl} item={game} headers={{ urlfield: 'id' }} className="icon-copyurl" classes="icon-dimensions-big" />
                     <Icon mode="copy-iframe" clearurl={clearurl} item={game} className="icon-copyframe" classes="icon-dimensions-big" />
                     <Icon mode="delete" url={'/api/grid/' + id} onRefreshHundler={onDeleted} className="icon-delete" classes="icon-dimensions-big" />
                  </div>
               </div>

               <GameCardsEditor gridId={id} type={game.type} />
            </div>
         </main>
         <GameModal modalState={modalState} gameId={id} onClose={closeModal} onSaved={onSaved} />
      </Layout>
   );
}
